import { dayjs } from "@/utils/dayjs";
import { toNumber } from "@/utils/number";
import { Dayjs } from "dayjs";

type TCalculateSpecifiedSkillFirstRemainingTermParams = {
  specifiedSkillFirstStartDate: Dayjs | null | undefined;
  blankPeriodMonthly: string | null | undefined;
};

export const calculateSpecificSkillTransitionPeriod = ({
  specifiedSkillFirstStartDate,
  blankPeriodMonthly,
}: TCalculateSpecifiedSkillFirstRemainingTermParams) => {
  const totalMonth = specifiedSkillFirstStartDate ? dayjs(new Date()).diff(specifiedSkillFirstStartDate, "M") - toNumber(blankPeriodMonthly) : 0;
  const yearPeriod = Math.floor(totalMonth / 12);
  const monthPeriod = totalMonth % 12;
  const period = specifiedSkillFirstStartDate
    ? `${yearPeriod > 0 ? yearPeriod + "年" : ""}${monthPeriod > 0 ? monthPeriod + "ヶ月" : ""}` || "0ヶ月"
    : "";

  return { period, yearPeriod: yearPeriod >= 0 ? yearPeriod : 0, monthPeriod: monthPeriod >= 0 ? monthPeriod : 0 };
};
